import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext({
  lang: "fr",
  setLang: () => {},
  t: translations.fr,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem("smk_lang");
      return saved === "en" || saved === "fr" ? saved : "fr";
    } catch {
      return "fr";
    }
  });

  const setLang = (next) => {
    setLangState(next);
    try {
      localStorage.setItem("smk_lang", next);
    } catch {
      /* ignore */
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = { lang, setLang, t: translations[lang] };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
